/**
 * Breakpoint design tokens for responsive layouts.
 * Use these values for media queries and responsive component logic.
 * Values follow Tailwind CSS conventions.
 */
export const BREAKPOINTS = {
  xs: '475px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1400px',
  '3xl': '1600px',
} as const;
